import { MouseEvent, PropsWithChildren, ReactNode } from 'react'

import BaseModal from '../BaseModal'
import { ModalProps } from '../types'
import { H2 } from 'components/Typography'
import { CommonButton } from 'components/Button'

import {
  SuccessModalContainer,
  SuccessModalTitle,
  SuccessModalFooter,
  SuccessModalBody,
} from './styles'

interface SuccessModalProps extends ModalProps {
  isOpen: boolean
  title: ReactNode
  confirmBtnTitle: ReactNode
  onConfirm: (ev: MouseEvent<HTMLElement>) => void
}

function SuccessModal({
  isOpen,
  title,
  children,
  confirmBtnTitle,
  onConfirm,
  onRequestClose = onConfirm,
}: PropsWithChildren<SuccessModalProps>) {
  return (
    <BaseModal isOpen={isOpen} onRequestClose={onRequestClose}>
      <SuccessModalContainer>
        <SuccessModalTitle>
          <H2>{title}</H2>
        </SuccessModalTitle>
        <SuccessModalBody>{children}</SuccessModalBody>
        <SuccessModalFooter>
          <CommonButton variant="darkOutlined" onClick={onConfirm}>
            {confirmBtnTitle}
          </CommonButton>
        </SuccessModalFooter>
      </SuccessModalContainer>
    </BaseModal>
  )
}

export default SuccessModal
